import React, { Component } from 'react'

import '../styles/scss/chartist/chartist.scss'

class BarChart extends Component {
  render() {
    return (
      <div className="bar-chart" style={{height: '450px'}}></div>
    )
  }
}

export default BarChart
